import { DialogContent, DialogTitle } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import { ApproveIcon } from "core/Icons";
import PropTypes from "prop-types";
import React from "react";
import { GenericAlert, GenericDialog, GenericDialogActions, GenericGrid, GenericLabel, GenericNumberInput, GenericTextInput } from "views/Components/Generic";
import GridButton from "views/Components/GridButton";
import LoadingComponent from "views/Components/LoadingComponent";

// Customer naming is used to make it consistent with previous implementation so clients won't be confused
class PayeeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: {
                Program: this.props.Program,
                UniqueClientId: this.props.UniqueClientId,
                CustomerName: this.props.CustomerName,
                CustomerNumber: this.props.CustomerNumber,
            },
            dialog: {
                isOpen: false,
                dialogData: []
            },
            selected: -1,
            isLoading: false
        };

        this.columns = [{
            Header: "Actions",
            accessor: "Actions",
            Cell: row => (
                <div>
                    <GridButton
                        tooltip="Select"
                        Icon={ApproveIcon}
                        OnClick={() => { this.HandleSelectModel(row.original, row.index); }} />
                </div>
            ),
            sortable: false,
            filterable: false,
            resizable: false,
            width: 60
        },
            {
                Header: "Customer Name",
                accessor: "PayeeName"
            },
            {
                Header: "Customer Email",
                accessor: "PayeeEmail"
            },
            {
                Header: "Customer Phone Number",
                accessor: "PhoneNumber"
            }];
    }

    componentDidMount() {
        const model = { ...this.state.model };
        model.Program = this.props.Program;
        model.UniqueClientId = this.props.UniqueClientId;
        model.CustomerName = this.props.CustomerName;
        model.CustomerNumber = this.props.CustomerNumber;
        if (this.props.KnownCustomer)
            this.HandleClickByKeyPressed();
    }

    HandleChange = (name, value) => {
        const model = { ...this.state.model };
        model[name] = value;
        model.Program = this.props.Program;
        model.UniqueClientId = this.props.UniqueClientId;
        this.setState({ model });
    }


    HandleClickInside = () => {
        const model = { ...this.state.model };
        this.setState({ isLoading: true });
        Proxy.POST("/bankapi/v1.0/ClientCustomer/GetCustomerMainPayee",
            {
                PayeeName: model.PayeeName,
                PayeePhoneNumber: model.PayeePhoneNumber,
                PayeeEmail: model.PayeeEmail,
                ProgramCode: this.props.Program,
                UniqueClientId: this.props.UniqueClientId
            },
            responseData => {
                this.setState({ isLoading: false });
                if (responseData.Item != null) {
                    this.setState({
                        dialog: {
                            isOpen: true,
                            dialogData: responseData.Item
                        }
                    });
                } else {
                    this.setState({ dialogData: [] });
                }
            },
            error => {
                this.setState({ isLoading: false });
                this.ShowMessage("error", "Error", error);
            });
    }

    HandleSelectModel = (model, index) => {
        this.setState({ selected: index });
        this.props.FillCallback(model);
        this.setState({
            dialog: {
                ...this.state.dialog,
                isOpen: false
            },
        });
    };

    CancelSelectCallback = () => {
        this.setState({
            dialog: {
                isOpen: false,
                dialogData: []
            },
            model: {},
            selected: -1
        });
    };

    RowSelected = (index) => {
        const model = this.state.dialog.dialogData[index];
        this.HandleSelectModel(model, index);
    }

    ShowMessage = (type, title, message) => {
        this.setState({
            alert: <GenericAlert Title={title} Message={message} Type={type} OnConfirm={() =>
                this.setState({ alert: "" })} />
        });
    }

    ShowMessageNode = (type, title, message) => {
        this.setState({
            alert: <GenericAlert Title={title} MessageNode={message} Type={type} OnConfirm={() =>
                this.setState({ alert: "" })} />
        });
    }

    ShowConfirmMessage = (type, title, message, onConfirm) => {
        this.setState({
            alert: <GenericAlert Title={title} Message={message} Type={type} ShowCancel={true} OnCancel={() => this.setState({ alert: null })} OnConfirm={onConfirm} />
        });
    }

    HandleClick = () => this.setState({
      dialog: {
          dialogData: [],
          isOpen: true
      },
      selected: -1
    });

    render() {
        const { classes, LabelMd, Disabled, ShowCustomerProgram, Required, IsInvalid } = this.props;
        const { model, dialog, isLoading } = this.state;

        var showColumns = [...this.columns];
        if (ShowCustomerProgram) {
            showColumns.push({
                Header: "Program",
                Cell: row => (
                    <div>
                        {row.original.Program.toString()}
                    </div>
                )
            });
        }

        return (
            <>
                <LoadingComponent Show={isLoading} />

                <GenericTextInput
                    LabelMd={LabelMd}
                    Name="Customer Name"
                    LabelText="Customer Name"
                    NoFormatting={true}
                    Value={this.props.Value?? "Search..."}
                    EndIconName={"search"}
                    IconOnClick={this.HandleClick}
                    Required={Required}
                    IsInvalid={IsInvalid}
                />

                <GenericDialog open={dialog.isOpen} onBackdropClick={this.CancelSelectCallback} maxWidth="md" fullWidth keepMounted={true}>
                    <DialogTitle><GenericLabel FontSize="16px" Text="Select Customer" Bold={true} />
                    </DialogTitle>
                    <DialogContent style={{ marginTop: 8 }}>
                        <GridContainer>
                            <GridItem xs={6}>
                                <GenericTextInput
                                    Name="PayeeName"
                                    LabelText="Customer Name"
                                    Value={model.PayeeName}
                                    ValueChanged={this.HandleChange} />
                            </GridItem>
                            <GridItem xs={6}>
                                <GenericTextInput
                                    Name="PayeeEmail"
                                    LabelText="Customer Email"
                                    Value={model.PayeeEmail}
                                    ValueChanged={this.HandleChange} />
                            </GridItem>
                            <GridItem xs={6}>
                                <GenericNumberInput
                                    Name="PayeePhoneNumber"
                                    LabelText="Customer Phone Number"
                                    NoFormatting={true}
                                    MaxLength={30}
                                    Value={model.PayeePhoneNumber}
                                    ValueChanged={this.HandleChange} />
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12}>
                                <br />
                                <GenericGrid
                                    Data={dialog.dialogData}
                                    Columns={showColumns}
                                    RowSelected={this.RowSelected}
                                    SelectedIndex={this.state.selected}
                                    HideButton={true}
                                    ShowPagination={true}
                                    PageSize={10}
                                />
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                    <GenericDialogActions>
                        <Button size="sm" onClick={this.HandleClickInside} >Search</Button>
                        <Button size="sm" onClick={this.CancelSelectCallback}>Cancel</Button>
                    </GenericDialogActions>
                </GenericDialog>
            </>
        );
    }
}

PayeeComponent.propTypes = {
    CustomerNumber: PropTypes.any,
    CustomerName: PropTypes.any,
    HandleChange: PropTypes.func,
    FillCallback: PropTypes.func,
    KnownCustomer: PropTypes.bool,
    LabelMd: PropTypes.number,
    UniqueClientId: PropTypes.number,
    Program: PropTypes.array,
    Disabled: PropTypes.bool,
    ShowCustomerProgram: PropTypes.bool,
};

PayeeComponent.defaultProps = {
    ShowCustomerProgram: false
};

export default withArtifex(PayeeComponent, {});